// Template styling constants for colors, background colors, and icons
export interface TemplateStyleOption {
  color: string;
  backgroundColor: string;
  name: string;
}

export interface TemplateIconOption {
  icon: string;
  name: string;
}

// Color and background color pairs from existing templates
export const TEMPLATE_COLOR_OPTIONS: TemplateStyleOption[] = [
  {
    color: '#FFFFFF',
    backgroundColor: '#3B82F6',
    name: 'Default',
  },
  {
    color: '#6366F1',
    backgroundColor: '#E0E7FF',
    name: 'Indigo',
  },
  {
    color: '#9333EA',
    backgroundColor: '#F3E8FF',
    name: 'Purple',
  },
  {
    color: '#10B981',
    backgroundColor: '#DCFCE7',
    name: 'Emerald',
  },
  {
    color: '#1d76f3',
    backgroundColor: '#8fd1ff',
    name: 'Blue',
  },
  {
    color: '#CA8A04',
    backgroundColor: '#FEF9C3',
    name: 'Amber',
  },
  {
    color: '#DB2777',
    backgroundColor: '#FCE7F3',
    name: 'Pink',
  },
  {
    color: '#DC2626',
    backgroundColor: '#FEE2E2',
    name: 'Red',
  },
  {
    color: '#059669',
    backgroundColor: '#D1FAE5',
    name: 'Green',
  },
  {
    color: '#7C3AED',
    backgroundColor: '#EDE9FE',
    name: 'Violet',
  },
  {
    color: '#EA580C',
    backgroundColor: '#FED7AA',
    name: 'Orange',
  },
];

// Icon options from existing templates in workflow-template.tsx
export const TEMPLATE_ICON_OPTIONS: TemplateIconOption[] = [
  {
    icon: 'WorkflowIcon',
    name: 'Default',
  },
  {
    icon: 'StickyNote',
    name: 'Blank Canvas',
  },
  {
    icon: 'FileUp',
    name: 'Import from File',
  },
  {
    icon: 'DatabaseZap',
    name: 'Database',
  },
  {
    icon: 'SearchIcon',
    name: 'Search',
  },
  {
    icon: 'BookOpen',
    name: 'Book',
  },
  {
    icon: 'FileBarChart',
    name: 'Chart',
  },
  {
    icon: 'GalleryThumbnails',
    name: 'Gallery',
  },
  {
    icon: 'Code',
    name: 'Code',
  },
];

// Default template styling
export const DEFAULT_TEMPLATE_STYLE: TemplateStyleOption =
  TEMPLATE_COLOR_OPTIONS[0]; // Default
export const DEFAULT_TEMPLATE_ICON: TemplateIconOption =
  TEMPLATE_ICON_OPTIONS[0]; // WorkflowIcon
